import _defineProperty from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Component } from 'react';
import RouteParamConstants from '../../utils/routeParamConstants';
import Validators from '../../components/Form/InputValidator';
import { checkIfOtpIsRequired } from './../OneTimePassword/utils';
import routeParamConstants from '../../utils/routeParamConstants';
import QueryParamsProxy from '../../utils/queryParamProxy';
import Screens from '../../screens';
import ENVIRONMENT_VARIABLES from '../../utils/environmentVariables';
import { REQUEST_STATE } from '../OneTimePassword/hooks/useOTPrequestHandler';
import store from '../../state/store';
import { postOTPSendEmail } from '../../state/query/oneTimePassword';
import { ServerResponseKeys } from '../../api/Constants';
import { getText, TEXT_KEY } from '../../utils/localization';
import { postLinkLoyaltyCard } from '../../state/query/linkLoyaltyCard';
import Logger from '../../lib/analytics/logger';
import { EVENT_TYPES } from '../../lib/analytics/constants';
import ERROR_CODE from '../../utils/errorCodes';
var LinkAccountForm = /*#__PURE__*/function (_Component) {
  function LinkAccountForm() {
    var _this;
    _classCallCheck(this, LinkAccountForm);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, LinkAccountForm, [].concat(args));
    _this.state = {
      error: null,
      message: null,
      success: false
    };
    _this.clearError = function () {
      _this.setState({
        error: null
      });
    };
    _this.isBodyValid = function (values) {
      return Validators.LENGTH_EQUALTO(values.year, 4) && Validators.NUMBERS_ONLY(parseInt(values.year, 10)) && Validators.NOT_EMPTY(values.month) && Validators.NOT_EMPTY(values.day) && Validators.ADULT_ONLY("".concat(values.year, "-").concat(values.month, "-").concat(values.day)) && Validators.NOT_EMPTY(values.accountNumber);
    };
    _this.isPinAccountValid = function (values) {
      return Validators.NOT_EMPTY(values.accountNumber) && Validators.NOT_EMPTY(values.pin);
    };
    _this.isPropertyValid = function (value) {
      return Validators.NOT_EMPTY(value);
    };
    _this.setPropertyId = function (userProperty, propertyId) {
      return userProperty === 1 ? propertyId : userProperty;
    };
    _this.handlePinAndAccount = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(values) {
        var accountNumber, pin;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              accountNumber = values.accountNumber, pin = values.pin;
              if (_this.isPinAccountValid({
                accountNumber: accountNumber,
                pin: pin
              })) {
                _context.next = 4;
                break;
              }
              _this.setState({
                success: false,
                error: getText(TEXT_KEY.FORM_INVALID_ERROR)
              });
              return _context.abrupt("return", false);
            case 4:
              _this.linkAccount({
                cardnum: accountNumber,
                pin: pin
              });
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();
    _this.handlePinPropertyAccount = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(values) {
        var userProperty, accountNumber, pin, propertyId;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              userProperty = _this.props.userProperty;
              accountNumber = values.accountNumber, pin = values.pin, propertyId = values.propertyId;
              if (!(!_this.isPinAccountValid({
                accountNumber: accountNumber,
                pin: pin
              }) || userProperty === 1 && !_this.isPropertyValid(propertyId) && hasPropertySelector)) {
                _context2.next = 5;
                break;
              }
              _this.setState({
                success: false,
                error: getText(TEXT_KEY.FORM_INVALID_ERROR)
              });
              return _context2.abrupt("return", false);
            case 5:
              _this.linkAccount({
                cardnum: accountNumber,
                pin: pin,
                propertyId: propertyId
              });
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }();
    _this.handleLinkAccount = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(values) {
        var _this$props, userProperty, propertySelector, valuesWithZeros, accountNumber, year, month, day, propertyId, dataObject, otpRequired, _error$data;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this$props = _this.props, userProperty = _this$props.userProperty, propertySelector = _this$props.propertySelector;
              valuesWithZeros = _objectSpread({}, values);
              valuesWithZeros.day = _this._addZeroPrefixToValue(valuesWithZeros.day);
              valuesWithZeros.month = _this._addZeroPrefixToValue(valuesWithZeros.month);
              if (!(!_this.isBodyValid(valuesWithZeros) || userProperty === 1 && !_this.isPropertyValid(valuesWithZeros.propertyId) && hasPropertySelector)) {
                _context3.next = 7;
                break;
              }
              _this.setState({
                success: false,
                error: getText(TEXT_KEY.AGE_UNDER_18_OR_FORM_INCOMPLETE_ERROR)
              });
              return _context3.abrupt("return", false);
            case 7:
              accountNumber = valuesWithZeros.accountNumber, year = valuesWithZeros.year, month = valuesWithZeros.month, day = valuesWithZeros.day, propertyId = valuesWithZeros.propertyId;
              dataObject = {
                cardnum: accountNumber,
                pin: "".concat(year, "-").concat(month, "-").concat(day)
              };
              if (userProperty && hasPropertySelector) dataObject.propertyId = _this.setPropertyId(userProperty, propertyId);
              otpRequired = checkIfOtpIsRequired(_this.setPropertyId(userProperty, propertyId), propertySelector);
              try {
                _this.checkToLinkAccount(otpRequired, dataObject);
              } catch (error) {
                _this.setState({
                  success: false,
                  error: error === null || error === void 0 || (_error$data = error.data) === null || _error$data === void 0 ? void 0 : _error$data.message
                });
              }
            case 12:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }();
    _this.checkToLinkAccount = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(otpRequired, dataObject) {
        var pin, propertyId, cardnum, otpValidationRequest, otpAuthTransaction, otpPromise, response, _error$data2;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!otpRequired) {
                _context4.next = 19;
                break;
              }
              pin = dataObject.pin, propertyId = dataObject.propertyId, cardnum = dataObject.cardnum;
              _context4.prev = 2;
              _context4.next = 5;
              return store.dispatch(postOTPSendEmail.initiate(_objectSpread(_objectSpread({}, propertyId && {
                propertyId: propertyId
              }), {}, {
                cardnum: cardnum,
                dob: pin
              }))).unwrap();
            case 5:
              otpValidationRequest = _context4.sent;
              otpAuthTransaction = otpValidationRequest[ServerResponseKeys.CALL_RESPONSE].otpAuthTransaction;
              otpPromise = QueryParamsProxy.setQueryParamsWithModalPromise(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, RouteParamConstants.PARAM_MODAL, Screens.OneTimePassword), RouteParamConstants.PARAM_OTP_PROPERTY_ID, propertyId), RouteParamConstants.PARAM_OTP_CARD_NUMBER, cardnum), RouteParamConstants.PARAM_OTP_DOB, pin), RouteParamConstants.PARAM_OTP_TRANSACTION_ID, otpAuthTransaction === null || otpAuthTransaction === void 0 ? void 0 : otpAuthTransaction.transactionId), RouteParamConstants.PARAM_OTP_USER_ID, otpAuthTransaction === null || otpAuthTransaction === void 0 ? void 0 : otpAuthTransaction.userId));
              _context4.next = 10;
              return otpPromise;
            case 10:
              response = _context4.sent;
              if ((response === null || response === void 0 ? void 0 : response.success) === REQUEST_STATE.AUTHENTICATE) _this.linkAccount(dataObject);
              _context4.next = 17;
              break;
            case 14:
              _context4.prev = 14;
              _context4.t0 = _context4["catch"](2);
              _this.setState({
                success: false,
                error: _context4.t0 === null || _context4.t0 === void 0 || (_error$data2 = _context4.t0.data) === null || _error$data2 === void 0 ? void 0 : _error$data2.message
              });
            case 17:
              _context4.next = 20;
              break;
            case 19:
              _this.linkAccount(dataObject);
            case 20:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[2, 14]]);
      }));
      return function (_x4, _x5) {
        return _ref4.apply(this, arguments);
      };
    }();
    _this.linkAccount = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(dataObject) {
        var response, success, _response$error, error, _response$msg, message, _this$props2, setCasinoIdStatus, setCasinoId, setCurrentMemberLevel, isAccountLinked, getFetchProperties, casinoId, casinoIdStatus, currentMemberLevel;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 3;
              return store.dispatch(postLinkLoyaltyCard.initiate(dataObject)).unwrap();
            case 3:
              response = _context5.sent;
              if (response) {
                _context5.next = 6;
                break;
              }
              return _context5.abrupt("return", false);
            case 6:
              success = response.success, _response$error = response.error, error = _response$error === void 0 ? '' : _response$error, _response$msg = response.msg, message = _response$msg === void 0 ? '' : _response$msg;
              if (!success) {
                _this.setState({
                  success: success,
                  error: error
                });
              } else {
                _this.setState({
                  success: success,
                  message: message
                });
                _this$props2 = _this.props, setCasinoIdStatus = _this$props2.setCasinoIdStatus, setCasinoId = _this$props2.setCasinoId, setCurrentMemberLevel = _this$props2.setCurrentMemberLevel, isAccountLinked = _this$props2.isAccountLinked, getFetchProperties = _this$props2.getFetchProperties;
                casinoId = response.casinoId, casinoIdStatus = response.casinoIdStatus, currentMemberLevel = response.currentMemberLevel;
                getFetchProperties();
                setCasinoIdStatus(casinoIdStatus);
                setCasinoId(casinoId);
                setCurrentMemberLevel(currentMemberLevel);
                isAccountLinked('yes');
                _this.navigateToScreen(undefined);
              }
              _context5.next = 13;
              break;
            case 10:
              _context5.prev = 10;
              _context5.t0 = _context5["catch"](0);
              Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
                error: JSON.stringify(_context5.t0),
                code: ERROR_CODE.LINK_LOYALTY_CARD_ERROR
              });
            case 13:
            case "end":
              return _context5.stop();
          }
        }, _callee5, null, [[0, 10]]);
      }));
      return function (_x6) {
        return _ref5.apply(this, arguments);
      };
    }();
    _this.navigateToScreen = function (screen) {
      return QueryParamsProxy.setQueryParams(_defineProperty({}, routeParamConstants.PARAM_MODAL, screen));
    };
    _this.handleRegisterRewardCard = function () {
      return _this.navigateToScreen(Screens.RegisterRewardCard);
    };
    _this._addZeroPrefixToValue = function (value) {
      var newValue = value;
      if (parseInt(newValue, 10) < 10) {
        newValue = "0".concat(parseInt(newValue, 10));
      }
      return newValue;
    };
    _this.findSelectedPropertyObject = function (selectedPropertyId) {
      return _this.props.propertySelector.find(function (property) {
        return property.propertyId === Number(selectedPropertyId);
      });
    };
    return _this;
  }
  _inherits(LinkAccountForm, _Component);
  return _createClass(LinkAccountForm, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        linkedLoyaltyCardBonus = _this$props3.linkedLoyaltyCardBonus,
        userProperty = _this$props3.userProperty,
        propertySelector = _this$props3.propertySelector,
        enableOrderCard = _this$props3.enableOrderCard;
      var _this$state = this.state,
        success = _this$state.success,
        error = _this$state.error,
        message = _this$state.message;
      return this.props.render({
        handleLinkAccount: this.handleLinkAccount,
        handlePinAndAccount: this.handlePinAndAccount,
        handlePinPropertyAccount: this.handlePinPropertyAccount,
        handleRegisterRewardCard: this.handleRegisterRewardCard,
        clearError: this.clearError,
        linkedLoyaltyCardBonus: linkedLoyaltyCardBonus,
        termsAndConditionsUrl: this.props.assetsUrls ? this.props.assetsUrls.termsAndConditions : '',
        success: success,
        error: error,
        message: message,
        userProperty: userProperty,
        propertySelector: propertySelector,
        setPropertyId: this.setPropertyId,
        enableOrderCard: enableOrderCard,
        findSelectedPropertyObject: this.findSelectedPropertyObject
      });
    }
  }]);
}(Component);
export { LinkAccountForm as default };
var hasPropertySelector = ENVIRONMENT_VARIABLES.SHOW_PROPERTY_SELECTOR;